/* Auraline Premium 3D Scroll Effects
 * Lightweight, GPU-accelerated animations
 * All effects respect Shopify theme customizer settings
 */
(function() {
  'use strict';

  // Read settings from data attributes on body
  const body = document.body;
  const enabled = body.dataset.auralineAnimations !== 'false';
  const smoothScroll = body.dataset.auralineSmoothScroll !== 'false';
  const hoverEffects = body.dataset.auralineHoverEffects !== 'false';
  const animStyle = body.dataset.auralineAnimStyle || 'fade-slide';
  const scrollSpeed = parseFloat(body.dataset.auralineScrollSpeed) || 0.6;
  const parallaxIntensity = parseInt(body.dataset.auralineParallaxIntensity) || 30;

  if (!enabled) return;

  // Smooth scroll
  if (smoothScroll) {
    document.documentElement.style.scrollBehavior = 'smooth';
  }

  // Intersection Observer for scroll animations
  const observerOptions = {
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px'
  };

  function getInitialTransform() {
    switch (animStyle) {
      case 'fade': return 'translate3d(0,0,0)';
      case 'slide': return 'translate3d(0,60px,0)';
      case 'zoom': return 'scale3d(0.92,0.92,1)';
      case 'fade-slide': return 'translate3d(0,40px,0)';
      default: return 'translate3d(0,40px,0)';
    }
  }

  function getFinalTransform() {
    switch (animStyle) {
      case 'zoom': return 'scale3d(1,1,1)';
      default: return 'translate3d(0,0,0)';
    }
  }

  // Apply initial styles to animatable elements
  const animSelectors = [
    '.section',
    '.hero',
    '.auraline-collection',
    '.product-card',
    '.collection-card',
    '.auraline-card',
    '[data-auraline-animate]',
    '.color-scheme-auraline-luxury',
    '.spacing-style'
  ].join(',');

  const elements = document.querySelectorAll(animSelectors);
  elements.forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = getInitialTransform();
    el.style.transition = 'opacity ' + scrollSpeed + 's cubic-bezier(0.16,1,0.3,1), transform ' + scrollSpeed + 's cubic-bezier(0.16,1,0.3,1)';
    el.style.willChange = 'opacity, transform';
  });

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const el = entry.target;
        el.style.opacity = '1';
        el.style.transform = getFinalTransform();
        // Clean up will-change after animation
        setTimeout(function() {
          el.style.willChange = 'auto';
        }, scrollSpeed * 1000 + 100);
        observer.unobserve(el);
      }
    });
  }, observerOptions);

  elements.forEach(function(el) { observer.observe(el); });

  // Parallax effect on hero/banner sections
  if (parallaxIntensity > 0) {
    const parallaxEls = document.querySelectorAll('.hero__media-wrapper, .auraline-hero, [data-auraline-parallax]');
    
    if (parallaxEls.length > 0) {
      let ticking = false;
      
      function updateParallax() {
        const scrollY = window.pageYOffset;
        const factor = parallaxIntensity / 100;
        
        parallaxEls.forEach(function(el) {
          const rect = el.getBoundingClientRect();
          const elCenter = rect.top + rect.height / 2;
          const viewCenter = window.innerHeight / 2;
          const offset = (elCenter - viewCenter) * factor * 0.15;
          
          el.style.transform = 'translate3d(0,' + offset + 'px, 0)';
          el.style.willChange = 'transform';
        });
        
        ticking = false;
      }
      
      window.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }, { passive: true });
    }
  }

  // Hover micro-interactions
  if (hoverEffects) {
    const style = document.createElement('style');
    style.textContent = [
      '.product-card, .collection-card, .auraline-card, [data-auraline-hover] {',
      '  transition: transform 0.35s cubic-bezier(0.16,1,0.3,1), box-shadow 0.35s cubic-bezier(0.16,1,0.3,1) !important;',
      '}',
      '.product-card:hover, .collection-card:hover, .auraline-card:hover, [data-auraline-hover]:hover {',
      '  transform: translateY(-4px) scale(1.015) !important;',
      '  box-shadow: 0 20px 60px -15px rgba(0,0,0,0.18), 0 0 20px rgba(212,175,55,0.08) !important;',
      '}',
      '.product-card img, .collection-card img, .auraline-card img {',
      '  transition: transform 0.6s cubic-bezier(0.16,1,0.3,1) !important;',
      '}',
      '.product-card:hover img, .collection-card:hover img, .auraline-card:hover img {',
      '  transform: scale(1.04) !important;',
      '}',
      'a.button, button.button, .auraline-btn {',
      '  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.3s ease !important;',
      '}',
      'a.button:hover, button.button:hover, .auraline-btn:hover {',
      '  transform: translateY(-2px) !important;',
      '  box-shadow: 0 8px 25px -8px rgba(212,175,55,0.3) !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // Image zoom on scroll effect
  const scrollZoomImages = document.querySelectorAll('.hero__image, .hero__media-wrapper img');
  if (scrollZoomImages.length > 0) {
    let zoomTicking = false;
    
    function updateZoom() {
      const scrollY = window.pageYOffset;
      
      scrollZoomImages.forEach(function(img) {
        const rect = img.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          const progress = Math.min(scrollY / (window.innerHeight * 0.8), 0.08);
          const scale = 1 + progress;
          img.style.transform = 'scale(' + scale + ')';
          img.style.transition = 'transform 0.1s linear';
        }
      });
      
      zoomTicking = false;
    }
    
    window.addEventListener('scroll', function() {
      if (!zoomTicking) {
        requestAnimationFrame(updateZoom);
        zoomTicking = true;
      }
    }, { passive: true });
  }

  // Reduce motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[style*="opacity: 0"]').forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.transition = 'none';
    });
  }

  // Disable heavy effects on mobile for performance
  if (window.innerWidth < 768) {
    document.querySelectorAll('.hero__media-wrapper, .auraline-hero').forEach(function(el) {
      el.style.transform = 'none';
      el.style.willChange = 'auto';
    });
  }
})();
